import "./DRPSectionDivider.scss";
const DRPSectionDivider = ({ section }) => {
  return (
    <div className="mm-section mm-spacing" style={{ marginTop: 40 }}>
      {section}
    </div>
  );
};
export default DRPSectionDivider;
